import { useState } from "react";
import { useLocation } from "wouter";
import { useMutation } from "@tanstack/react-query";
import { apiRequest, queryClient } from "@/lib/queryClient";
import { useStore } from "@/lib/store";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Field, FieldLabel } from "@/components/ui/field";
import { ShieldCheck } from "lucide-react";

export default function AcceptInvitePage() {
  const [location] = useLocation();
  const { setAuthToken } = useStore();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const browserQS = typeof window !== "undefined" ? window.location.search : "";
  const queryString = browserQS || (location.includes("?") ? location.split("?")[1] : "");
  const token = new URLSearchParams(
    queryString.startsWith("?") ? queryString.slice(1) : queryString
  ).get("token");

  const acceptInviteMutation = useMutation({
    mutationFn: async () => {
      if (!token) throw new Error("Brak tokenu zaproszenia");
      return apiRequest("POST", `/api/agency/invitations/${encodeURIComponent(token)}/accept`, {
        password,
      });
    },
    onSuccess: (data: any) => {
      setAuthToken(data.token);
      queryClient.clear();
      window.location.href = "/";
    },
    onError: (err: any) => {
      setError(err?.message?.replace(/^\d+:\s*/, "") || "Nie udało się zaakceptować zaproszenia");
    },
  });

  return (
    <div className="min-h-screen bg-[#030407] flex items-center justify-center p-4">
      <Card className="w-full max-w-md bg-[#0a0c10] border-white/[0.1]">
        <CardHeader className="text-center">
          <ShieldCheck className="w-10 h-10 text-[#ef3e29] mx-auto mb-2" />
          <CardTitle className="text-white">Aktywuj zaproszenie</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {!token ? (
            <p className="text-sm text-red-300 text-center">Link zaproszenia jest nieprawidłowy.</p>
          ) : (
            <>
              <Field>
                <FieldLabel>Ustaw hasło</FieldLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError(null);
                  }}
                  placeholder="Minimum 6 znaków"
                  className="bg-white/[0.08] border-white/[0.1] text-white"
                />
              </Field>
              {error && <p className="text-xs text-red-300">{error}</p>}
              <Button
                className="w-full bg-[#ef3e29] hover:bg-[#d93520] text-white"
                disabled={password.length < 6 || acceptInviteMutation.isPending}
                onClick={() => acceptInviteMutation.mutate()}
              >
                {acceptInviteMutation.isPending ? "Aktywuję..." : "Dołącz do zespołu"}
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
